module.exports = __webpack_public_path__ + "img/bg-img-news-and-announcements-tablet.60c9c4d5.png";